export default __webpack_public_path__ + "static/media/a012-market-line-5.82da1d07.svg";